/**
 * tdesign v1.5.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _toConsumableArray } from '../../_chunks/dep-be6b014c.mjs';
import { defineComponent, ref, computed, createVNode, createTextVNode } from 'vue';
import { PaginationMini } from '../../pagination/index.mjs';
import { Select } from '../../select/index.mjs';
import { usePrefixClass } from '../../hooks/useConfig.mjs';
import { useConfig } from '../../config-provider/useConfig.mjs';
import '../../_chunks/dep-558fadc3.mjs';
import '../../pagination/pagination.mjs';
import '../../_chunks/dep-b9505f3d.mjs';
import '../../_chunks/dep-1ec078b3.mjs';
import '../../_chunks/dep-34428f12.mjs';
import '../../_chunks/dep-af8c0169.mjs';
import '../../_chunks/dep-1c40d002.mjs';
import '../../_chunks/dep-8a0ff305.mjs';
import '../../_chunks/dep-61150968.mjs';
import 'tdesign-icons-vue-next';
import '../../hooks/useGlobalIcon.mjs';
import '../../_chunks/dep-1f286011.mjs';
import '../../_chunks/dep-3ced59c9.mjs';
import '../../_chunks/dep-4371fb57.mjs';
import '../../_chunks/dep-31d34e52.mjs';
import '../../_chunks/dep-67e8723b.mjs';
import '../../_chunks/dep-0bf03d55.mjs';
import '../../_chunks/dep-5b5daf08.mjs';
import '../../_chunks/dep-95049222.mjs';
import '../../_chunks/dep-ac19a2b6.mjs';
import '../../_chunks/dep-90d97bcb.mjs';
import '../../_chunks/dep-c8679a16.mjs';
import '../../_chunks/dep-939a74d6.mjs';
import '../../_chunks/dep-e9ff4ce8.mjs';
import '../../_chunks/dep-c54c9f32.mjs';
import '../../_chunks/dep-e4f65bc4.mjs';
import '../../_chunks/dep-45572c49.mjs';
import '../../_chunks/dep-1aa18f5f.mjs';
import '../../_chunks/dep-e09a06d8.mjs';
import '../../_chunks/dep-07f3660d.mjs';
import '../../_chunks/dep-0d3220b0.mjs';
import '../../_chunks/dep-895678a0.mjs';
import '../../_chunks/dep-b2bdc7b9.mjs';
import '../../_chunks/dep-0f45a6e0.mjs';
import '../../_chunks/dep-b390ff23.mjs';
import '../../_chunks/dep-35a4fd8d.mjs';
import '../../_chunks/dep-54378e60.mjs';
import '../../_chunks/dep-25b8bf4b.mjs';
import '../../_chunks/dep-c40264c0.mjs';
import '../../_chunks/dep-9d499243.mjs';
import '../../_common/js/global-config/default-config.mjs';
import '../../_common/js/global-config/locale/zh_CN.mjs';
import '../../_chunks/dep-0927ceb7.mjs';
import '../../_chunks/dep-f0bd05df.mjs';
import '../../config-provider/type.mjs';
import '../../input-number/index.mjs';
import '../../input-number/input-number.mjs';
import '../../_chunks/dep-fa22eda7.mjs';
import '../../button/index.mjs';
import '../../button/button.mjs';
import '../../loading/index.mjs';
import '../../loading/directive.mjs';
import '../../loading/plugin.mjs';
import '../../loading/loading.mjs';
import '../../loading/icon/gradient.mjs';
import '../../_common/js/loading/circle-adapter.mjs';
import '../../_common/js/utils/set-style.mjs';
import '../../_common/js/utils/helper.mjs';
import '../../_chunks/dep-51567b45.mjs';
import '../../_chunks/dep-9a7888c7.mjs';
import '../../utils/dom.mjs';
import '../../utils/easing.mjs';
import '../../utils/render-tnode.mjs';
import '../../_chunks/dep-55311368.mjs';
import '../../_chunks/dep-c25d13e7.mjs';
import '../../_chunks/dep-2a69909d.mjs';
import '../../_chunks/dep-c24f5c5d.mjs';
import '../../_chunks/dep-79d42d5d.mjs';
import '../../_chunks/dep-979d7716.mjs';
import '../../_chunks/dep-8b3be089.mjs';
import '../../_chunks/dep-84053b94.mjs';
import '../../_chunks/dep-398227bb.mjs';
import '../../loading/props.mjs';
import '../../hooks/useTeleport.mjs';
import '../../utils/withInstall.mjs';
import './style/css.mjs';
import '../../loading/type.mjs';
import '../../button/props.mjs';
import '../../hooks/useRipple.mjs';
import '../../hooks/useKeepAnimation.mjs';
import '../../utils/set-style.mjs';
import '../../hooks/tnode.mjs';
import '../../hooks/useDisabled.mjs';
import '../../_chunks/dep-44e322cb.mjs';
import '../../button/type.mjs';
import '../../input/index.mjs';
import '../../input/input.mjs';
import '../../input/props.mjs';
import '../../form/hooks.mjs';
import '../../input/useInput.mjs';
import '../../form/const.mjs';
import '../../hooks/index.mjs';
import '../../hooks/icon.mjs';
import '../../hooks/slot.mjs';
import '../../hooks/useCommonClassName.mjs';
import '../../hooks/useDefaultValue.mjs';
import '../../hooks/useDestroyOnClose.mjs';
import '../../hooks/useVirtualScroll.mjs';
import '../../hooks/useVModel.mjs';
import '../../hooks/useImagePreviewUrl.mjs';
import '../../_common/js/upload/utils.mjs';
import '../../_common/js/log/log.mjs';
import '../../input/useLengthLimit.mjs';
import '../../_common/js/log/index.mjs';
import '../../input/useInputEventHandler.mjs';
import '../../input/useInputWidth.mjs';
import '../../input/input-group.mjs';
import '../../input/input-group-props.mjs';
import '../../input/type.mjs';
import '../../input-number/props.mjs';
import '../../input-number/useInputNumber.mjs';
import '../../_common/js/input-number/number.mjs';
import '../../_common/js/input-number/large-number.mjs';
import '../../input-number/type.mjs';
import '../../input-adornment/index.mjs';
import '../../input-adornment/input-adornment.mjs';
import '../../input-adornment/props.mjs';
import '../../input-adornment/type.mjs';
import '../../pagination/props.mjs';
import '../../pagination/usePaginationClasses.mjs';
import '../../pagination/useMoreAction.mjs';
import '../../select/select.mjs';
import '../../_chunks/dep-e524ff2f.mjs';
import '../../_chunks/dep-16b9f817.mjs';
import '../../_chunks/dep-6c1f8553.mjs';
import '../../_chunks/dep-437754aa.mjs';
import '../../_chunks/dep-6dbd6c24.mjs';
import '../../_chunks/dep-a861ee00.mjs';
import '../../_chunks/dep-3514a375.mjs';
import '../../_chunks/dep-154ff253.mjs';
import '../../_chunks/dep-e583fb66.mjs';
import '../../_chunks/dep-a059cf4b.mjs';
import '../../common-components/fake-arrow.mjs';
import '../../select-input/index.mjs';
import '../../select-input/select-input.mjs';
import '../../popup/index.mjs';
import '../../popup/popup.mjs';
import '@popperjs/core';
import '../../popup/container.mjs';
import '../../popup/props.mjs';
import '../../hooks/useResizeObserver.mjs';
import '../../popup/type.mjs';
import '../../select-input/props.mjs';
import '../../select-input/useSingle.mjs';
import '../../select-input/useMultiple.mjs';
import '../../tag-input/index.mjs';
import '../../tag-input/tag-input.mjs';
import '../../tag-input/props.mjs';
import '../../tag-input/hooks/useTagScroll.mjs';
import '../../tag-input/useTagList.mjs';
import '../../tag/index.mjs';
import '../../tag/tag.mjs';
import '../../tag/props.mjs';
import '../../tag/check-tag.mjs';
import '../../tag/check-tag-props.mjs';
import '../../tag/type.mjs';
import '../../tag-input/hooks/useHover.mjs';
import '../../tag-input/hooks/useDragSorter.mjs';
import '../../tag-input/type.mjs';
import '../../select-input/useOverlayInnerStyle.mjs';
import '../../select-input/type.mjs';
import '../../select/select-panel.mjs';
import '../../_chunks/dep-ad4331e8.mjs';
import '../../_chunks/dep-e40749a5.mjs';
import '../../select/option.mjs';
import '../../select/option-props.mjs';
import '../../checkbox/index.mjs';
import '../../checkbox/checkbox.mjs';
import '../../checkbox/props.mjs';
import '../../checkbox/constants.mjs';
import '../../checkbox/hooks/useCheckboxLazyLoad.mjs';
import '../../_common/js/utils/observe.mjs';
import '../../checkbox/hooks/useKeyboard.mjs';
import '../../checkbox/group.mjs';
import '../../checkbox/checkbox-group-props.mjs';
import '../../checkbox/type.mjs';
import '../../select/helper.mjs';
import '../../select/optionGroup.mjs';
import '../../select/option-group-props.mjs';
import '../../select/props.mjs';
import '../../select/hooks/usePanelVirtualScroll.mjs';
import '../../select/hooks/useSelectOptions.mjs';
import '../../select/type.mjs';
import '../../pagination/pagination-mini.mjs';
import '../../pagination/pagination-mini-props.mjs';
import '../../pagination/type.mjs';

var TDateHeader = defineComponent({
  name: "TDatePickerHeader",
  props: {
    mode: {
      type: String,
      "default": "date"
    },
    year: Number,
    month: Number,
    onMonthChange: Function,
    onYearChange: Function,
    onJumperClick: Function
  },
  setup: function setup(props) {
    var _useConfig = useConfig("classPrefix"),
      classPrefix = _useConfig.classPrefix;
    var COMPONENT_NAME = usePrefixClass("date-picker__header");
    var _useConfig2 = useConfig("datePicker"),
      globalConfig = _useConfig2.globalConfig;
    var yearOptions = ref(initOptions(props.year));
    var showMonthPicker = props.mode === "date" || props.mode === "week";
    var nearestYear = computed(function () {
      var _yearOptions$value$fi;
      return ((_yearOptions$value$fi = yearOptions.value.find(function (option) {
        return option.value - props.year <= 9 && option.value - props.year >= 0;
      })) === null || _yearOptions$value$fi === void 0 ? void 0 : _yearOptions$value$fi.value) || props.year;
    });
    var monthOptions = computed(function () {
      return globalConfig.value.months.map(function (item, index) {
        return {
          label: item,
          value: index
        };
      });
    });
    function initOptions(year) {
      var options = [];
      if (props.mode === "year") {
        var extraYear = year % 10;
        var minYear = year - extraYear - 100;
        var maxYear = year - extraYear + 100;
        for (var i = minYear; i <= maxYear; i += 10) {
          options.push({
            label: "".concat(i, " - ").concat(i + 9),
            value: i + 9
          });
        }
      } else {
        options.push({
          label: "".concat(year),
          value: year
        });
        for (var _i = 1; _i <= 10; _i++) {
          options.push({
            label: "".concat(year + _i),
            value: year + _i
          });
          options.unshift({
            label: "".concat(year - _i),
            value: year - _i
          });
        }
      }
      return options;
    }
    function loadMoreYear(year, type) {
      var options = [];
      if (props.mode === "year") {
        var extraYear = year % 10;
        if (type === "add") {
          for (var i = year - extraYear + 10; i <= year - extraYear + 50; i += 10) {
            options.push({
              label: "".concat(i, " - ").concat(i + 9),
              value: i
            });
          }
        } else {
          for (var _i2 = year - extraYear - 1; _i2 > year - extraYear - 50; _i2 -= 10) {
            options.unshift({
              label: "".concat(_i2 - 9, " - ").concat(_i2),
              value: _i2
            });
          }
        }
      } else if (type === "add") {
        for (var _i3 = year + 1; _i3 <= year + 10; _i3++) {
          options.push({
            label: "".concat(_i3),
            value: _i3
          });
        }
      } else {
        for (var _i4 = year - 1; _i4 > year - 10; _i4--) {
          options.unshift({
            label: "".concat(_i4),
            value: _i4
          });
        }
      }
      return options;
    }
    var labelMap = {
      year: {
        prev: globalConfig.value.preDecade,
        current: globalConfig.value.now,
        next: globalConfig.value.nextDecade
      },
      month: {
        prev: globalConfig.value.preYear,
        current: globalConfig.value.now,
        next: globalConfig.value.nextYear
      },
      date: {
        prev: globalConfig.value.preMonth,
        current: globalConfig.value.now,
        next: globalConfig.value.nextMonth
      }
    };
    function handleScroll(_ref) {
      var e = _ref.e;
      if (e.target.scrollTop === 0) {
        handlePanelTopClick(e);
      } else if (e.target.scrollTop === e.target.scrollHeight - e.target.clientHeight) {
        handlePanelBottomClick(e);
      }
    }
    function handlePanelTopClick(e) {
      var _e$stopPropagation;
      e === null || e === void 0 || (_e$stopPropagation = e.stopPropagation) === null || _e$stopPropagation === void 0 ? void 0 : _e$stopPropagation.call(e);
      var firstYear = yearOptions.value[0].value;
      var options = loadMoreYear(firstYear, "reduce");
      yearOptions.value = [].concat(_toConsumableArray(options), _toConsumableArray(yearOptions.value));
    }
    function handlePanelBottomClick(e) {
      var _e$stopPropagation2;
      e === null || e === void 0 || (_e$stopPropagation2 = e.stopPropagation) === null || _e$stopPropagation2 === void 0 ? void 0 : _e$stopPropagation2.call(e);
      var lastYear = yearOptions.value.slice(-1)[0].value;
      var options = loadMoreYear(lastYear, "add");
      yearOptions.value = [].concat(_toConsumableArray(yearOptions.value), _toConsumableArray(options));
    }
    return function () {
      return createVNode("div", {
        "class": COMPONENT_NAME.value
      }, [createVNode("div", {
        "class": "".concat(COMPONENT_NAME.value, "-controller")
      }, [showMonthPicker && createVNode(Select, {
        "class": "".concat(COMPONENT_NAME.value, "-controller-month"),
        "value": props.month,
        "options": monthOptions.value,
        "onChange": function onChange(val) {
          var _props$onMonthChange;
          return (_props$onMonthChange = props.onMonthChange) === null || _props$onMonthChange === void 0 ? void 0 : _props$onMonthChange.call(props, val);
        },
        "popupProps": {
          attach: function attach(triggerElement) {
            return triggerElement.parentNode;
          },
          overlayClassName: "".concat(COMPONENT_NAME.value, "-controller-month-popup")
        }
      }, null), createVNode(Select, {
        "class": "".concat(COMPONENT_NAME.value, "-controller-year"),
        "value": props.mode === "year" ? nearestYear.value : props.year,
        "options": yearOptions.value,
        "onChange": function onChange(val) {
          var _props$onYearChange;
          return (_props$onYearChange = props.onYearChange) === null || _props$onYearChange === void 0 ? void 0 : _props$onYearChange.call(props, val);
        },
        "popupProps": {
          onScroll: handleScroll,
          attach: function attach(triggerElement) {
            return triggerElement.parentNode;
          },
          overlayClassName: "".concat(COMPONENT_NAME.value, "-controller-year-popup")
        },
        "panelTopContent": function panelTopContent() {
          return createVNode("div", {
            "class": "".concat(classPrefix.value, "-select-option"),
            "onClick": handlePanelTopClick
          }, [createTextVNode("...")]);
        },
        "panelBottomContent": function panelBottomContent() {
          return createVNode("div", {
            "class": "".concat(classPrefix.value, "-select-option"),
            "onClick": handlePanelBottomClick
          }, [createTextVNode("...")]);
        }
      }, null)]), createVNode(PaginationMini, {
        "tips": labelMap[props.mode],
        "size": "small",
        "onChange": props.onJumperClick
      }, null)]);
    };
  }
});

export { TDateHeader as default };
//# sourceMappingURL=Header.mjs.map
